export default __webpack_public_path__ + "static/media/Wasp.58ac102e.svg";